import React, { useCallback, useState } from 'react';
import { testComplete } from '../../api/apiHandler';
import { showPromiseNotification } from '../../common/notification';
import { useTranslation } from 'react-i18next';
import '../../i18';

const CompleteTestModal = ({ isOpen, isClose, onSubmit, attempted, courseId, testId, isTestSubmit, stopTimer, onCorrectAnsUpdate }) => {
    const { t } = useTranslation();

    const [correctAns, setCorrectAns] = useState(0);
    const [errorMessage, setErrorMessage] = useState('');

    const handleSkippedQuestions = () => {
        const skippedQuestions = attempted.filter(item => item.option_id === 0);
        if (skippedQuestions.length === 0) {
            setErrorMessage(t('noQueToReview'));
        } else {
            onSubmit(skippedQuestions);
            isClose();
        }
    };

    const handleTestSubmit = useCallback(
        async () => {
            stopTimer();
            const myPromise = new Promise(async (resolve, reject) => {
                await testComplete({
                    course_id: courseId,
                    test_id: testId,
                    user_test_data: attempted.length > 0 ? attempted : [{ "question_id": 0, "option_id": 0 }]
                })
                    .then((response) => {
                        if (response.code == 200) {
                            setCorrectAns(response.data?.correct_answer);
                            onCorrectAnsUpdate(response.data?.correct_answer);
                            resolve(response);
                            localStorage.removeItem("testStartingTimer")
                            isTestSubmit();
                            isClose();
                        }
                        else {
                            reject(response);
                        }
                    })
            })

            showPromiseNotification(myPromise);
        }, [courseId, testId, attempted, isClose, isTestSubmit]
    );

    if (!isOpen) return null;

    const skippedQuestionsCount = attempted.filter(item => item.option_id === 0).length;

    return (
        <div className="modal fade show modal-overlay" style={{ display: 'block' }} aria-modal="true" role="dialog">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h1 className="modal-title fs-5">{t('testModalHeading')}</h1>
                        <button
                            type="button"
                            className="btn-close"
                            onClick={isClose}
                            aria-label="Close"
                        />
                    </div>
                    <div className="modal-body">
                        <h2 className="ModalHeading">
                            {t('fillSkippedQue')}
                        </h2>
                        <ul className="ModalAttemptedUl">
                            <li className="ModalAttemptedLi">
                                <p className="modaltext">{t('attemptedQue')}</p>
                                <p className="modaltextNumber">{attempted.length > 0
                                    ? attempted.filter(item => item.option_id !== 0 && item.question_id).length
                                    : 0}
                                </p>
                            </li>
                            <li className="ModalAttemptedLi">
                                <p className="modaltext">{t('unAttemptedQue')}</p>
                                <p className="modaltextNumber">{skippedQuestionsCount}</p>
                            </li>
                        </ul>
                        {errorMessage && <p className="error-message">{errorMessage}</p>}
                    </div>
                    <div className="modal-footer d-flex justify-content-center gap-3">
                        <button
                            type="button"
                            className="btn btn-border-black b-animate-3"
                            onClick={handleSkippedQuestions}
                            disabled={skippedQuestionsCount === 0}
                        >
                            {t('reviewSkippedQue')}
                        </button>
                        <button
                            type="button"
                            className="btn btn-base b-animate-3 ConfirmTestResults"
                            onClick={handleTestSubmit}
                        >
                            {t('confirm')}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CompleteTestModal;